import BaseModule from './BaseModule'

class ValidatableForm extends BaseModule {
	constructor(o) {
		super(o);

		this.enable();
	}

	enable() {
		super.enable()

		const form = this.el
		form.addEventListener(
			'submit',
			function(event) {
				if (form.reportValidity() === false) {
					event.preventDefault()
					event.stopPropagation()
				}

				form.classList.add('was-validated')
			},
			false
		);
	}
}

export default ValidatableForm
